module.exports = __webpack_public_path__ + "img/codetochem.4c0b9006.png";